import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackbar: MatSnackBar) { }

  open(message: string, config: MatSnackBarConfig = { duration: 2000 }) {
    this.snackbar.open(message, null, config);
  }
}
